{
  "notifications": {
    "title": "Notifications",
    "markAllRead": "Mark all as read",
    "viewAll": "View all notifications",
    "empty": "No notifications",
    "emptyDescription": "You're all caught up!",
    "new": "new",
    "today": "Today",
    "yesterday": "Yesterday",
    "earlier": "Earlier",
    "justNow": "Just now",
    "minutesAgo": "{{count}} minute ago",
    "minutesAgo_plural": "{{count}} minutes ago",
    "hoursAgo": "{{count}} hour ago",
    "hoursAgo_plural": "{{count}} hours ago",
    "daysAgo": "{{count}} day ago",
    "daysAgo_plural": "{{count}} days ago",
    "categories": {
      "status_change": "Status Update",
      "correspondence": "Correspondence",
      "deadline": "Deadline",
      "approval_needed": "Approval Needed",
      "filing_complete": "Filing Complete",
      "new_filing": "New Filing",
      "office_action": "Office Action",
      "system": "System"
    },
    "urgency": {
      "low": "Low",
      "medium": "Medium",
      "high": "High",
      "critical": "Critical"
    },
    "actions": {
      "view": "View",
      "dismiss": "Dismiss",
      "markRead": "Mark as read"
    }
  }
}
